{
  "price_editor_page": {
    "title": "Price editor",
    "description": "The price editor lets you easily make changes to your B2B pricing without needing to upload a CSV file.",
    "footer": "Learn more about the price editor",
    "search_placeholder": "Search prices by ID, name, description, barcode, variant SKU, or variant options"
  },
  "variant_pricing_page": {
    "title": "Price editor",
    "description": "Manage the B2B pricing for variant {sku}.",
    "not_found": "The product \"{sku}\" could not be found. However, you can still add pricing for this SKU."
  }
}
